var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "mycanvas", attrs: { id: "mycanvas" } }, [
    _c(
      "div",
      { attrs: { id: "mycanvas-controls" } },
      [
        _vm.selectedAnimation
          ? _c("v-btn", { on: { click: _vm.resizeToggle } }, [
              _vm._v(_vm._s(_vm.transformControlMode))
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-015cbfee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015cbfee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/preview.vue
// module id = null
// module chunks = 